import React, { useEffect, useState } from "react";
import successcart from "../assets/images/success-cart.svg";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteCartItemApi,
  updateCartQuantity,
  updateCartQuantityAPI,
} from "./features/cartSlice";
import defaultimg from "../assets/images/default-img.png";
import Address1 from "./Address1";
import {
  fetchAddressList,
  setAddressList,
  setSelectedAddress,
} from "./features/addressSlice";
import easebuzz_logo from "../assets/images/easebuzz_logo.jpeg";
import "react-phone-input-2/lib/style.css";
import UserDetailsForm from "./UserDetailsForm";
import { clearGuestUser, setGuestUserDetails } from "./features/userSlice";
import MobileVerificationSection from "./MobileVerificationSection";
import DeliveryCharges from "./DeliveryCharges";
import { UpdateProfile } from "./Utils/ValidateSaveUser";
import { CouponType } from "../constants";
import GreetingNoteSection from "./CheckoutComponents/GreetingNoteSection";
import OrderNoteSection from "./CheckoutComponents/OrderNoteSection";
import { fetchUserDetails } from "./features/userDetailSlice";
import OtpInput from "./OtpInput";

const Checkout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isPageLoading, setIsPageLoading] = useState(true);
  const { items, loading, error, cartId } = useSelector((state) => state.cart);
  const {
    addressList,
    loading: addressLoading,
    error: addressError,
  } = useSelector((user) => user.address);
  // console.log(addressList, "addressList");
  // Handle different cart data structures
  const getCartProducts = () => {
    if (!cartId) {
      // Check for items directly first
      if (items && items.length > 0) {
        return items;
      }
      return [];
    }

    // If cartId is an array, use it directly
    if (Array.isArray(cartId)) {
      return cartId;
    }

    // If cartId has products property and it's an array
    if (cartId?.products && Array.isArray(cartId.products)) {
      return cartId.products;
    }

    // If there are items in localStorage
    const localCartItems = JSON.parse(localStorage.getItem("cartItems"));
    if (Array.isArray(localCartItems) && localCartItems.length > 0) {
      return localCartItems;
    }

    // Default to empty array if no valid cart data found
    return [];
  };

  const newCartId = getCartProducts();
  // console.log("Cart data in Checkout:", { cartId, items, newCartId });

  // Map products only if we have valid cart data
  let arr = newCartId.map((arr) => {
    return {
      ...arr,
      product_id: arr.product_id?.["_id"] || arr.product_id || null,
    };
  });

  const { user, token } = useSelector((state) => state.auth);
  const userId = user?.id;
  const [isOrderNoteChecked, setIsOrderNoteChecked] = useState(false);
  const [isGreetingNoteChecked, setIsGreetingNoteChecked] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const [selectedAddressId, setSelectedAddressId] = useState("");
  const [coupons, setCoupons] = useState([]);
  const [isOrderNoteText, setIsOrderNoteText] = useState("");
  const [isGreetingNoteText, setIsGreetingNoteText] = useState("");
  const [orderId, setOrderId] = useState(null);
  const [isIncrementLoading, setIsIncrementLoading] = useState(false);
  const [isDecrementLoading, setIsDecrementLoading] = useState(false);
  const [couponId, setCouponId] = useState(null);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  const [showMobileModal, setShowMobileModal] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [isUpdatingMobile, setIsUpdatingMobile] = useState(false);
  const [userDetails, setUserDetails] = useState({
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    countryCode: "+91",
    gender: "",
  });
  const [verifyMethod, setVerifyMethod] = useState("email");
  const [verifyEmail, setVerifyEmail] = useState("");
  const [verifyMobile, setVerifyMobile] = useState("");
  const [verifyCountryCode, setVerifyCountryCode] = useState("+91");
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otp, setOtp] = useState("");
  const [isProcessingOtp, setIsProcessingOtp] = useState(false);
  const [canSendOtp, setCanSendOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  const [verifiedUser, setVerifiedUser] = useState(null);
  const [isNewUser, setIsNewUser] = useState(false);
  const guestUser = useSelector((state) => state.user?.guestUser);
  const [deliveryCharge, setDeliveryCharge] = useState(0);
  const [selectedCourierId, setSelectedCourierId] = useState(null);
  const [selectedGreetingCard, setSelectedGreetingCard] = useState("");
  const { userDetail, loading: userDetailLoading } = useSelector(
    (state) => state.userDetail
  );

  // Verify coupon api
  const verifyCoupon = async () => {
    const toastId = "verify-coupon-code-Id";
    if (!couponCode) {
      if (!toast.isActive(toastId)) {
        toast.error("Please enter a coupon code", {
          toastId: toastId,
        });
      }
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/coupons/validate`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
          body: JSON.stringify({
            userId: userId,
            couponCode: couponCode,
            cartId: cartId,
          }),
        }
      );
      const data = await response.json();
      if (data.success) {
        toast.success(data.message);
        setDiscount(data.responseObject.discount);
        setCouponId(data.responseObject._id);
      } else {
        toast.error(data.message);
        setCouponCode("");
        setDiscount(0);
        setCouponId(null);
      }
    } catch (error) {
      toast.error(error.message);
      // console.log("error coupon apply", error);
    }
  };

  const fetchCoupons = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/coupons/user${
          token ? "" : "/all"
        }`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      // console.log("data from fetch coupons", data);
      if (data.success) {
        setCoupons(data.responseObject);
      }
    } catch (error) {
      toast.error("Failed to fetch coupons");
      // console.error("Error fetching coupons:", error);
    }
  };

  const handleAddressSelect = (addressId) => {
    setSelectedAddressId(addressId);
    dispatch(setSelectedAddress(addressId));
  };

  // Replace fetchUserProfile with Redux action
  useEffect(() => {
    if (token) {
      dispatch(fetchUserDetails());
    }
  }, [token, dispatch]);

  // Update the userProfile and userDetails state when userDetail changes
  useEffect(() => {
    if (userDetail) {
      setUserProfile(userDetail);
      setUserDetails({
        firstName: userDetail.firstName || "",
        lastName: userDetail.lastName || "",
        mobile: userDetail.mobile ? userDetail.mobile.toString() : "",
        email: userDetail.email || "",
        countryCode: userDetail.countryCode || "+91",
        gender: userDetail.gender || "",
        ...userDetail,
      });
    }
  }, [userDetail]);

  // Modify the success modal close handlers
  const handleModalClose = () => {
    const successModalEl = document.querySelector("#success");
    const successModal = window.bootstrap.Modal.getInstance(successModalEl);
    if (successModal) {
      successModal.hide();
    }

    // Remove modal classes and restore scrolling
    document.body.classList.remove("modal-open");
    const modalBackdrop = document.querySelector(".modal-backdrop");
    if (modalBackdrop) {
      modalBackdrop.remove();
    }
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  };

  // delete cart ITem
  const handleRemoveItem = (productId, weightId) => {
    const cartItem = items.find((item) => {
      return (
        item.productId?._id === productId && item.weightId?._id === weightId
      );
    });

    if (cartItem) {
      dispatch(
        deleteCartItemApi({
          productId: token ? cartItem.productId._id : cartItem.product_id,
          weightId: cartItem.weightId._id,
        })
      ).then(() => {
        if (items.length === 1) {
          toast.info("Cart is now empty");
          navigate("/shop");
        }
      });
    }
  };

  const handleIncreaseQuantity = async (
    productId,
    currentQuantity,
    stockQty,
    weightId
  ) => {
    const cartItem = items.find((item) => {
      return (
        item.productId?._id === productId && item.weightId?._id === weightId
      );
    });

    if (cartItem) {
      const stockLimit = token
        ? cartItem.weightId.stock
        : cartItem.weights.find(
            (w) => w.weightInGrams === cartItem.weightId.weightInGrams
          )?.stock;

      if (cartItem.quantity >= stockLimit) {
        toast.info(`Sorry, only ${stockLimit} items available in stock`);
        return;
      }

      setIsIncrementLoading(true);
      try {
        await dispatch(
          updateCartQuantityAPI(
            token ? cartItem.productId._id : cartItem.product_id,
            cartItem.quantity + 1,
            cartItem.weightId._id
          )
        );
      } catch (error) {
        toast.error("Failed to update quantity");
      } finally {
        setIsIncrementLoading(false);
      }
    }
  };

  const handleDecreaseQuantity = async (
    productId,
    currentQuantity,
    stockQty,
    weightId
  ) => {
    const cartItem = items.find((item) => {
      return (
        item.productId?._id === productId && item.weightId?._id === weightId
      );
    });

    if (cartItem) {
      setIsDecrementLoading(true);
      try {
        if (cartItem.quantity > 1) {
          await dispatch(
            updateCartQuantityAPI(
              token ? cartItem.productId._id : cartItem.product_id,
              cartItem.quantity - 1,
              cartItem.weightId._id
            )
          );
        } else {
          await dispatch(
            deleteCartItemApi({
              productId: token ? cartItem.productId._id : cartItem.product_id,
              weightId: cartItem.weightId._id,
            })
          );
        }
      } catch (error) {
        toast.error("Failed to update quantity");
      } finally {
        setIsDecrementLoading(false);
      }
    }
  };

  const handleInputChange = async (productId, event, grams) => {
    const newQuantity = parseInt(event.target.value, 10);
    if (!isNaN(newQuantity) && newQuantity >= 1) {
      try {
        dispatch(
          updateCartQuantity({ productId, quantity: newQuantity, grams })
        );
        await dispatch(updateCartQuantityAPI(productId, newQuantity, grams));
      } catch (error) {
        toast.error("Failed to update quantity");
      }
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetchCoupons();
    dispatch(fetchAddressList());
    // Ensure loader shows for at least 0.4 seconds
    const timer = setTimeout(() => {
      setIsPageLoading(false);
    }, 400);

    return () => clearTimeout(timer);
  }, []);

  const removeCoupon = () => {
    setCouponCode("");
    setDiscount(0);
    setCouponId(null);
    toast.success("Coupon removed successfully");
  };

  // Calculate order details function
  const calculateOrderDetails = async () => {
    // if (!selectedAddressId) {
    //   setOrderDetails({
    //     summary: {
    //       subtotal: 0,
    //       finalAmount: 0,
    //       totalCGST: 0,
    //       totalSGST: 0,
    //       couponDiscount: 0
    //     }
    //   });
    //   return;
    // }
    try {
      const payload = token
        ? { cartId: cartId, shippingAddressData: selectedAddressId }
        : {
            cartItems: items.map((item) => ({
              productId: item.productId?._id || item.product_id,
              weightId: item.weightId?._id,
              quantity: item.quantity,
            })),
          };

      if (couponId) {
        payload.couponId = couponId;
      }

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/orders/calculate`,
        {
          method: "POST",
          headers: {
            ...(token && { Authorization: `Bearer ${token}` }),
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();
      // console.log("data from calculate order details", data);
      if (data.success) {
        setOrderDetails(data.responseObject);
        const applicableCoupon = coupons.find(
          // yeah i know its a spelling mistake
          (coupon) => coupon._id === couponId
        );
        if (
          applicableCoupon &&
          orderDetails.summary.subtotal < applicableCoupon.minimumOrderAmount
        ) {
          removeCoupon(); // Remove the coupon if the cart value is below the minimum
        }
      }
    } catch (error) {
      console.error("Error calculating order details:", error);
      toast.error("Failed to calculate order details");
    }
  };

  useEffect(() => {
    calculateOrderDetails();
  }, [items, couponId]);

  const handleDeliveryChargeUpdate = (
    charge,
    shouldRecalculate = false,
    courierId = null
  ) => {
    setDeliveryCharge(charge);
    if (courierId) {
      setSelectedCourierId(courierId);
    }
    if (shouldRecalculate) {
      calculateOrderDetails();
    }
  };

  const renderOrderSummary = () => {
    if (!orderDetails?.summary) {
      return (
        <div className="text-center p-3">
          <div className="spinner-border spinner-border-sm" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      );
    }

    return (
      <>
        <div className="d-flex justify-content-between mb-2">
          <span>Subtotal</span>
          <span>
            {orderDetails.summary.subtotal?.toLocaleString("en-IN", {
              style: "currency",
              currency: "INR",
            }) || "₹0.00"}
          </span>
        </div>

        <DeliveryCharges
          orderDetails={orderDetails}
          selectedAddress={addressList.find(
            (addr) => addr._id === selectedAddressId
          )}
          selectedAddressId={selectedAddressId}
          onChargeUpdate={handleDeliveryChargeUpdate}
        />

        {/* {orderDetails.summary.totalCGST > 0 && (
          <div className="d-flex justify-content-between mb-2">
            <span>CGST</span>
            <span>
              {orderDetails.summary.totalCGST?.toLocaleString("en-IN", {
                style: "currency",
                currency: "INR",
              }) || "₹0.00"}
            </span>
          </div>
        )} */}

        {/* {orderDetails.summary.totalSGST > 0 && (
          <div className="d-flex justify-content-between mb-2">
            <span>SGST</span>
            <span>
              {orderDetails.summary.totalSGST?.toLocaleString("en-IN", {
                style: "currency",
                currency: "INR",
              }) || "₹0.00"}
            </span>
          </div>
        )} */}

        {orderDetails.summary.couponDiscount > 0 && (
          <div className="d-flex justify-content-between mb-2">
            <span>Coupon Discount</span>
            <span className="text-success">
              -₹{orderDetails.summary.couponDiscount?.toFixed(2) || "0.00"}
            </span>
          </div>
        )}

        <div className="d-flex justify-content-between fw-bold border-top pt-2">
          <span>Total (Inc. all taxes)</span>
          <span>
            {(
              orderDetails.summary.finalAmount + deliveryCharge
            )?.toLocaleString("en-IN", {
              style: "currency",
              currency: "INR",
            }) || "₹0.00"}
          </span>
        </div>
        <div className="text-left text-muted mb-2" style={{ fontSize: "12px" }}>
          <span>
            Including ₹{orderDetails.summary.totalTax?.toFixed(2) || "0.00"} in
            taxes
          </span>
        </div>
      </>
    );
  };

  const checkExistingUser = async (type, value) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/check-exists`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type,
            value,
          }),
        }
      );
      const data = await response.json();
      const exists = data.success && data.responseObject.exists;
      setIsNewUser(!exists);
      setCanSendOtp(exists);
      return data.exists;
    } catch (error) {
      console.error("Error checking user:", error);
      toast.error("Failed to verify user details");
      setCanSendOtp(false);
      return false;
    }
  };

  useEffect(() => {
    if (verifyMethod === "email" && verifyEmail) {
      // Add basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (emailRegex.test(verifyEmail)) {
        checkExistingUser("email", verifyEmail);
      } else {
        setCanSendOtp(false);
        setIsNewUser(false);
      }
    } else if (verifyMethod === "mobile" && verifyMobile) {
      // Add basic mobile validation (at least 10 digits)
      if (verifyMobile.length >= 10) {
        checkExistingUser("mobile", verifyMobile);
      } else {
        setCanSendOtp(false);
        setIsNewUser(false);
      }
    } else {
      setCanSendOtp(false);
      setIsNewUser(false);
      // Reset verification states when input is cleared
      if (verifyMethod === "email" && !verifyEmail) {
        setUserDetails((prev) => ({
          ...prev,
          email: "",
        }));
      } else if (verifyMethod === "mobile" && !verifyMobile) {
        setUserDetails((prev) => ({
          ...prev,
          mobile: "",
          countryCode: verifyCountryCode,
        }));
      }
    }
  }, [verifyEmail, verifyMobile, verifyMethod]);

  // Update the button text to be more informative
  const getButtonText = () => {
    if (isProcessingOtp) {
      return "Sending...";
    }
    if (isNewUser) {
      return verifyMethod === "email" ? "" : "";
    }
    if (!canSendOtp) {
      return "";
    }
    return "Send OTP";
  };

  // Add a function to validate email
  const validateEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (verifyMethod === "email" && verifyEmail && !emailRegex.test(verifyEmail)) {
      return "Please enter a valid email address";
    }
    return "";
  };

  const handleSendMobileOtp = async () => {
    setIsProcessingOtp(true);
    try {
      if (!verifyEmail && verifyMethod === "email") {
        toast.error("Please enter a valid email address");
        return;
      }

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/emails/send-email-otp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: "Guest User",
            email: verifyEmail,
          }),
        }
      );

      const data = await response.json();
      if (data.success) {
        setShowOtpInput(true);
        toast.success("OTP sent successfully");
      } else {
        toast.error(data.message || "Failed to send OTP");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to process request");
    } finally {
      setIsProcessingOtp(false);
    }
  };

  const handleVerifyOtp = async () => {
    setIsVerifyingOtp(true);
    try {
      if (!otp || otp.length !== 4) {
        toast.error("Please enter a valid OTP");
        return;
      }

      if (verifyMethod === "mobile") {
        // handled in mobileverficationsection componentt
      } else {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/emails/verify-otp`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              email: verifyEmail,
              otp: otp,
            }),
          }
        );

        const data = await response.json();
        if (data.success) {
          const userData = data.responseObject;
          const userInfo = {
            ...userDetails, // Keep existing details
            firstName: userData.firstName || userDetails.firstName,
            lastName: userData.lastName || userDetails.lastName,
            email: userData.email || verifyEmail,
            mobile: userData.mobile || userDetails.mobile,
            countryCode: userData.countryCode || userDetails.countryCode,
          };

          setVerifiedUser(userData);
          setUserDetails(userInfo);
          dispatch(setGuestUserDetails(userInfo));

          // If user has addresses, populate them
          if (userData.addresses && userData.addresses.length > 0) {
            dispatch(setAddressList(userData.addresses));
            handleAddressSelect(userData.addresses[0]._id);
          }

          toast.success("Email verification successful");
          setShowOtpInput(false);
        } else {
          toast.error(data.message);
        }
      }
    } catch (error) {
      console.error("Error verifying:", error);
      toast.error("Verification failed");
    } finally {
      setIsVerifyingOtp(false);
    }
  };

  const createGuestOrder = async () => {
    try {
      // Clean and format the mobile number
      const cleanMobile = String(guestUser.mobile)
        .replace(/[^0-9]/g, "")
        .replace(/^91/, "")
        .slice(-10);

      // First create guest user if not already created
      let guestUserData;
      if (!guestUser?._id) {
        const createGuestUserResponse = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/users/create-guest`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              firstName: userDetails.firstName,
              lastName: userDetails.lastName,
              email: userDetails.email,
              mobile: cleanMobile,
              countryCode: userDetails.countryCode || "+91",
              isEmailVerified: true,
              isMobileVerified: true,
            }),
          }
        );

        const response = await createGuestUserResponse.json();
        if (!response.success) {
          throw new Error(response.message);
        }
        guestUserData = response.responseObject;
      } else {
        guestUserData = guestUser;
      }

      // Get selected address
      const selectedAddress = addressList.find(
        (addr) => addr._id === selectedAddressId
      );
      if (!selectedAddress) {
        throw new Error("Please select a delivery address");
      }

      // Prepare address data
      const addressToSave = {
        userId: token ? userId : guestUserData._id,
        userModel: "GuestUser",
        type: selectedAddress.type,
        buildingName: selectedAddress.buildingName,
        street: selectedAddress.street,
        landmark: selectedAddress.landmark || "",
        city: selectedAddress.city,
        district: selectedAddress.district,
        state: selectedAddress.state,
        postalCode: selectedAddress.postalCode,
        country: selectedAddress.country || "India",
        isDefault: false,
        isGuest: true,
      };

      // Check if address already exists in addressList
      const matchingAddressesCount = addressList.filter(
        (addr) =>
          addr.street === addressToSave.street &&
          addr.city === addressToSave.city &&
          addr.district === addressToSave.district &&
          addr.state === addressToSave.state &&
          addr.postalCode === addressToSave.postalCode &&
          addr.buildingName === addressToSave.buildingName &&
          addr.landmark === addressToSave.landmark
      ).length;

      let addressId;

      if (matchingAddressesCount < 2) {
        const saveAddressResponse = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/addresses`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(addressToSave),
          }
        );

        const savedAddress = await saveAddressResponse.json();
        if (!savedAddress.success) {
          throw new Error(savedAddress.message || "Failed to save address");
        }
        addressId = savedAddress.responseObject._id;
      } else {
        // Use existing address ID
        const existingAddress = addressList.find(
          (addr) =>
            addr.street === addressToSave.street &&
            addr.city === addressToSave.city &&
            addr.district === addressToSave.district &&
            addr.state === addressToSave.state &&
            addr.postalCode === addressToSave.postalCode &&
            addr.buildingName === addressToSave.buildingName &&
            addr.landmark === addressToSave.landmark
        );
        addressId = existingAddress._id;
      }

      // Create cart for guest user if needed
      const cartItems = items.map((item) => ({
        productId: item.productId?._id || item.product_id,
        weightId: item.weightId?._id || item.weightId,
        quantity: item.quantity,
      }));

      const createCartResponse = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/carts/merge`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: guestUserData._id,
            items: cartItems,
          }),
        }
      );

      const cartData = await createCartResponse.json();
      if (!cartData.success) {
        throw new Error(cartData.message || "Failed to create cart");
      }

      // Create order with the saved address ID
      const createOrderResponse = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/orders`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: token ? userId : guestUserData._id,
            cartId: cartData.responseObject._id,
            shippingAddress: addressId,
            couponId: couponId,
            isGuestUser: true,
            orderNote: isOrderNoteChecked ? isOrderNoteText : "",
            deliveryCharges: deliveryCharge,
            courier_id: selectedCourierId,
            greetingNote: isGreetingNoteChecked
              ? {
                  message: isGreetingNoteText,
                  image: selectedGreetingCard,
                }
              : null,
          }),
        }
      );

      const orderData = await createOrderResponse.json();
      if (!orderData.success) {
        throw new Error(orderData.message || "Failed to create order");
      }

      // Initiate payment
      const paymentResponse = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/payments/initiate`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            orderId: orderData.responseObject._id,
          }),
        }
      );

      const paymentData = await paymentResponse.json();
      if (!paymentData.success) {
        throw new Error(paymentData.message);
      }

      // Clear guest user data after successful order creation
      dispatch(clearGuestUser());

      // Redirect to payment gateway
      window.location.href = paymentData.responseObject.paymentUrl;
    } catch (error) {
      console.error("Error in guest order creation:", error);
      toast.error(error.message || "Failed to create order");
      setIsProcessingPayment(false);
    }
  };

  const handlePayment = async () => {
    setIsProcessingPayment(true);
    if (!token) {
      // Guest user flow
      if (!guestUser) {
        toast.error("Please fill in your contact details");
        setIsProcessingPayment(false);
        return;
      }

      // Validate required fields first
      if (!userDetails.firstName || !userDetails.email) {
        toast.error("Please fill in all required contact details");
        setIsProcessingPayment(false);
        return;
      }

      // Validate mobile number format if it exists
      let cleanMobile = "";
      if (userDetails.mobile) {
        cleanMobile = String(userDetails.mobile)
          .replace(/[^0-9]/g, "")
          .slice(-10);
        if (!cleanMobile || cleanMobile.length !== 10) {
          toast.error("Please provide a valid 10-digit phone number");
          setIsProcessingPayment(false);
          return;
        }
      } else {
        toast.error("Please provide a mobile number");
        setIsProcessingPayment(false);
        return;
      }

      if (!selectedAddressId) {
        toast.error("Please select a delivery address");
        setIsProcessingPayment(false);
        return;
      }

      // Update guest user in Redux store before creating order
      dispatch(
        setGuestUserDetails({
          ...userDetails,
          mobile: cleanMobile,
          countryCode: userDetails.countryCode || "+91",
        })
      );

      await createGuestOrder();
      return;
    }

    try {
      await UpdateProfile(userDetails, userDetail?._id || user.id);

      // Get selected address
      const selectedAddress = addressList.find(
        (addr) => addr._id === selectedAddressId
      );
      if (!selectedAddress) {
        throw new Error("Please select a delivery address");
      }

      // Prepare shipping address data
      let shippingAddressData;
      if (token) {
        // For logged-in users, send address ID
        shippingAddressData = selectedAddressId;
      } else {
        // For new users, send complete address object
        shippingAddressData = selectedAddress
          ? {
              type: selectedAddress.type,
              buildingName: selectedAddress.buildingName,
              street: selectedAddress.street,
              landmark: selectedAddress.landmark,
              city: selectedAddress.city,
              district: selectedAddress.district,
              state: selectedAddress.state,
              postalCode: selectedAddress.postalCode,
              country: selectedAddress.country || "India",
            }
          : null;
      }

      const payload = {
        userId: token ? userId : guestUser._id,
        cartId: cartId,
        shippingAddress: token
          ? selectedAddressId
          : {
              userId: guestUser._id,
              userModel: "GuestUser",
              type: selectedAddress.type,
              buildingName: selectedAddress.buildingName,
              street: selectedAddress.street,
              landmark: selectedAddress.landmark || "",
              city: selectedAddress.city,
              district: selectedAddress.district,
              state: selectedAddress.state,
              postalCode: selectedAddress.postalCode,
              country: selectedAddress.country || "India",
              isDefault: false,
              isGuest: true,
            },
        couponId: couponId || null,
        orderNote: isOrderNoteChecked ? isOrderNoteText : "",
        deliveryCharges: deliveryCharge,
        isGuestUser: !token,
        courier_id: selectedCourierId,
        greetingNote: isGreetingNoteChecked
          ? {
              message: isGreetingNoteText,
              image: selectedGreetingCard,
            }
          : null,
      };

      const createOrderResponse = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/orders`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      const orderData = await createOrderResponse.json();
      if (!orderData.success) {
        throw new Error(orderData.message || "Failed to create order");
      }

      // Initiate payment with the created order
      const paymentResponse = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/payments/initiate`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            orderId: orderData.responseObject._id,
          }),
        }
      );

      const paymentData = await paymentResponse.json();
      if (!paymentData.success) {
        throw new Error(paymentData.message || "Failed to initiate payment");
      }

      // Redirect to payment gateway
      window.location.href = paymentData.responseObject.paymentUrl;
    } catch (error) {
      console.error("Payment error:", error);
      toast.error(error.message || "Failed to process payment");
    } finally {
      setIsProcessingPayment(false);
    }
  };

  // Add this effect to update UserDetailsForm when verification details change
  useEffect(() => {
    if (!token && (verifyEmail || verifyMobile)) {
      setUserDetails((prev) => ({
        ...prev,
        email: verifyEmail || prev.email,
        mobile:
          String(verifyMobile || "") // Convert to string before using replace
            .replace(/[^0-9]/g, "")
            .slice(-10) || prev.mobile,
        countryCode: verifyCountryCode || prev.countryCode,
      }));
    }
  }, [verifyEmail, verifyMobile, verifyCountryCode, token]);

  // Add this effect to update verification fields when UserDetailsForm changes
  useEffect(() => {
    if (!token) {
      if (verifyMethod === "email" && userDetails.email && !verifyEmail) {
        setVerifyEmail(userDetails.email);
      } else if (
        verifyMethod === "mobile" &&
        userDetails.mobile &&
        !verifyMobile
      ) {
        setVerifyMobile(userDetails.mobile);
        setVerifyCountryCode(userDetails.countryCode);
      }
    }
  }, [userDetails, verifyMethod, token]);

  if (isPageLoading) {
    return (
      <div className="loader-main" style={{ background: "white" }}>
        <div className="loaderaa"></div>
      </div>
    );
  }

  return (
    <>
      <section className="banner-innr" style={{ background: "#3c3260" }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-12 col-sm-12">
              <div className="banner-innr-content text-center">
                <h3 style={{ color: "white" }}>Checkout</h3>
                <p className="text-center mb-0" style={{ color: "white" }}>
                  Complete your order
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="checkout-section bg-light py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-9">
              <div className="row justify-content-center">
                <div className="col-lg-8 mb-4">
                  <div className="card border-0">
                    <div
                      className="card-header text-white py-3"
                      style={{ background: "#3c3260" }}
                    >
                      <h5 className="mb-0" style={{ color: "white" }}>
                        <i className="fas fa-shopping-cart me-2"></i> Order
                        Summary
                      </h5>
                    </div>
                    <div className="card-body p-3">
                      <div
                        className="overflow-auto"
                        style={{ maxHeight: "400px" }}
                      >
                        {items && items.length > 0 ? (
                          items.map((item) => (
                            <div
                              key={item?._id}
                              className="d-flex align-items-center border-bottom py-3"
                            >
                              <div
                                className="me-3"
                                style={{ width: "80px", height: "80px" }}
                              >
                                <Link
                                  to={`/productdetails/${item.productId.slug}`}
                                >
                                  <img
                                    src={
                                      item?.productId?.productImages?.[0] ||
                                      item?.image ||
                                      defaultimg
                                    }
                                    alt={item?.productId?.productName}
                                    className="img-fluid rounded"
                                    style={{
                                      objectFit: "cover",
                                      width: "100%",
                                      height: "100%",
                                      minWidth: "80px",
                                    }}
                                  />
                                </Link>
                              </div>
                              <div className="flex-grow-1">
                                <h6 className="mb-1 text-dark">
                                  {item?.productId?.productName}
                                </h6>
                                <p className="text-muted small mb-2">
                                  {item?.weightId.weightInGrams} gm
                                </p>
                                <div className="d-flex align-items-center">
                                  <button
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={() =>
                                      handleDecreaseQuantity(
                                        item?.productId._id,
                                        item.quantity,
                                        item?.weightId.stock,
                                        item?.weightId._id
                                      )
                                    }
                                  >
                                    <i className="fas fa-minus"></i>
                                  </button>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm mx-2 text-center"
                                    style={{ width: "60px" }}
                                    value={item.quantity}
                                    onChange={(e) =>
                                      handleInputChange(
                                        item?.productId._id,
                                        e,
                                        item?.weightId.weightInGrams,
                                        item?.weightId._id
                                      )
                                    }
                                    max={item?.weightId.stock}
                                  />
                                  <button
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={() =>
                                      handleIncreaseQuantity(
                                        item?.productId?._id,
                                        item.quantity,
                                        item?.weightId.stock,
                                        item?.weightId._id
                                      )
                                    }
                                  >
                                    <i className="fas fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                              <div className="text-end ms-3">
                                <span className="fw-bold text-success">
                                  {item.discountedPrice?.toLocaleString(
                                    "en-IN",
                                    {
                                      style: "currency",
                                      currency: "INR",
                                    }
                                  )}
                                </span>
                                <span className="text-muted fs-6 d-block">
                                  <del>
                                    {item.price?.toLocaleString("en-IN", {
                                      style: "currency",
                                      currency: "INR",
                                    })}
                                  </del>
                                </span>
                                <button
                                  className="btn btn-link text-danger p-0 mt-1"
                                  onClick={() =>
                                    handleRemoveItem(
                                      item?.productId._id,
                                      item?.weightId._id
                                    )
                                  }
                                >
                                  <i className="fas fa-trash-alt"></i>
                                </button>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="text-center">
                            <h1>Your cart is empty.</h1>
                            <Link
                              to="/shop"
                              style={{ borderRadius: "50px" }}
                              className="thm-btn mt-2 bg-btn"
                            >
                              Continue Shopping
                            </Link>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Only show these sections if cart is not empty */}
                    {(newCartId.length > 0 || items?.length > 0) && (
                      <>
                        {/* Coupon Section */}
                        <div className="card-footer bg-white">
                          <div className="input-group mb-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter coupon code"
                              value={couponCode}
                              onChange={(e) => setCouponCode(e.target.value)}
                              maxLength={50}
                              disabled={couponId !== null}
                            />
                            <button
                              className="thm-btn"
                              type="button"
                              onClick={verifyCoupon}
                              disabled={couponId !== null}
                            >
                              Apply
                            </button>
                          </div>

                          {/* Add View Coupons button */}
                          <button
                            className="btn btn-link text-primary p-0 mb-2"
                            onClick={() =>
                              document
                                .getElementById("couponsOffcanvas")
                                .classList.add("show")
                            }
                          >
                            <i className="fas fa-ticket-alt me-1"></i>
                            View Available Coupons
                          </button>

                          {discount > 0 && (
                            <div className="alert alert-success d-flex justify-content-between align-items-center mt-2">
                              <span>Applied Coupon: {couponCode}</span>
                              <button
                                className="btn btn-link text-danger p-0"
                                onClick={removeCoupon}
                              >
                                <i className="fas fa-times"></i>
                              </button>
                            </div>
                          )}
                        </div>

                        {/* Add Coupons Offcanvas/Drawer */}
                        <div
                          className="offcanvas offcanvas-end"
                          tabIndex="-1"
                          id="couponsOffcanvas"
                          aria-labelledby="couponsOffcanvasLabel"
                        >
                          <div className="offcanvas-header">
                            <h5
                              className="offcanvas-title"
                              id="couponsOffcanvasLabel"
                            >
                              Available Coupons
                            </h5>
                            <button
                              type="button"
                              className="btn-close text-reset bg-white"
                              onClick={() =>
                                document
                                  .getElementById("couponsOffcanvas")
                                  .classList.remove("show")
                              }
                              aria-label="Close"
                            ></button>
                          </div>
                          <div className="offcanvas-body">
                            {coupons.length > 0 ? (
                              coupons.map((coupon) => {
                                const isLoginRequired =
                                  !token &&
                                  coupon.couponType ===
                                    CouponType.REGISTERED_SINGLE_USE;
                                const isUsed =
                                  coupon.couponType ===
                                  CouponType.PUBLIC_MULTI_USE
                                    ? false
                                    : userProfile?.coupons?.includes(
                                        coupon._id
                                      );
                                return (
                                  <div
                                    key={coupon._id}
                                    className="card mb-3"
                                    style={{
                                      opacity:
                                        isLoginRequired || isUsed ? 0.7 : 1,
                                      background:
                                        isLoginRequired || isUsed
                                          ? "#f5f5f5"
                                          : "white",
                                      position: "relative",
                                    }}
                                  >
                                    <div className="card-body">
                                      <div className="d-flex justify-content-between align-items-start">
                                        <div>
                                          <h6 className="card-title mb-1">
                                            {coupon.couponName}
                                          </h6>
                                          <p className="card-text text-muted small mb-2">
                                            {coupon.description}
                                          </p>
                                          <span className="badge bg-success">
                                            {coupon.discount}% OFF
                                          </span>
                                          {coupon.minimumOrderAmount > 0 && (
                                            <span className="badge bg-info ms-2">
                                              Min. Order: ₹
                                              {coupon.minimumOrderAmount}
                                            </span>
                                          )}
                                          <br />
                                          {orderDetails?.summary &&
                                            orderDetails.summary.finalAmount <
                                              coupon.minimumOrderAmount && (
                                              <div
                                                style={{
                                                  color: "red",
                                                  fontSize: "12px",
                                                  marginTop: "4px",
                                                }}
                                              >
                                                Add items worth ₹
                                                {(
                                                  coupon.minimumOrderAmount -
                                                  orderDetails.summary
                                                    .finalAmount
                                                ).toFixed(0)}{" "}
                                                to avail this coupon
                                              </div>
                                            )}
                                        </div>

                                        <button
                                          className="btn btn-sm btn-outline-primary"
                                          onClick={() => {
                                            if (isLoginRequired || isUsed) {
                                              toast.info(
                                                isLoginRequired
                                                  ? "Please login to use this coupon"
                                                  : "You have already used this coupon"
                                              );
                                              return;
                                            }
                                            // First set the coupon code
                                            setCouponCode(coupon.coupenCode);
                                            // Close the drawer
                                            document
                                              .getElementById(
                                                "couponsOffcanvas"
                                              )
                                              .classList.remove("show");
                                            // Create a new verify function that uses the coupon code directly
                                            const verifySelectedCoupon =
                                              async () => {
                                                try {
                                                  const response = await fetch(
                                                    `${process.env.REACT_APP_BACKEND_URL}/api/coupons/validate`,
                                                    {
                                                      method: "POST",
                                                      headers: {
                                                        "Content-Type":
                                                          "application/json",
                                                        ...(token && {
                                                          Authorization: `Bearer ${token}`,
                                                        }),
                                                      },
                                                      body: JSON.stringify({
                                                        userId: userId,
                                                        couponCode:
                                                          coupon.coupenCode, // Use the coupon code directly
                                                        cartId: cartId,
                                                      }),
                                                    }
                                                  );
                                                  const data =
                                                    await response.json();
                                                  if (data.success) {
                                                    toast.success(data.message);
                                                    setDiscount(
                                                      data.responseObject
                                                        .discount
                                                    );
                                                    setCouponId(
                                                      data.responseObject._id
                                                    );
                                                  } else {
                                                    toast.error(data.message);
                                                  }
                                                } catch (error) {
                                                  toast.error(error.message);
                                                }
                                              };
                                            // Call the verify function immediately
                                            verifySelectedCoupon();
                                          }}
                                          disabled={isLoginRequired || isUsed}
                                        >
                                          Apply
                                        </button>
                                      </div>
                                      <div className="mt-2">
                                        <small className="text-muted">
                                          Valid till:{" "}
                                          {new Date(
                                            coupon.validTo
                                          ).toLocaleDateString()}
                                        </small>
                                      </div>

                                      {/* Login Required Overlay */}
                                      {(isLoginRequired || isUsed) && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            bottom: "10px",
                                            right: "10px",
                                            background: "#3c3260",
                                            color: "white",
                                            padding: "3px 8px",
                                            borderRadius: "3px",
                                            fontSize: "0.7rem",
                                          }}
                                        >
                                          {isLoginRequired
                                            ? "Login Required"
                                            : "Already Used"}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <div className="text-center text-muted py-4">
                                <i className="fas fa-ticket-alt fa-2x mb-2"></i>
                                <p>No coupons available at the moment</p>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Order Total */}
                        <div className="card-footer bg-white">
                          {renderOrderSummary()}
                        </div>
                      </>
                    )}
                  </div>
                </div>

                {!token && (
                  <div className="col-lg-8 mb-4">
                    <div className="card shadow-sm border-0">
                      <div className="card-header bg-white">
                        <h5 className="mb-0">
                          {isNewUser ? "Create Account" : "Verify Contact"}
                        </h5>
                      </div>
                      <div className="card-body">
                        <div className="mb-3">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="verifyMethod"
                              id="verifyEmail"
                              checked={verifyMethod === "email"}
                              onChange={() => setVerifyMethod("email")}
                              maxLength={100}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="verifyEmail"
                            >
                              Email
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="verifyMethod"
                              id="verifyMobile"
                              checked={verifyMethod === "mobile"}
                              onChange={() => setVerifyMethod("mobile")}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="verifyMobile"
                            >
                              Mobile
                            </label>
                          </div>
                        </div>

                        {verifyMethod === "email" ? (
                          <div className="mb-3">
                            <label className="form-label">Email Address</label>
                            <div className="input-group">
                              <input
                                type="email"
                                className={`form-control ${validateEmail() ? 'is-invalid' : ''}`}
                                value={verifyEmail}
                                onChange={(e) => setVerifyEmail(e.target.value)}
                                placeholder="Enter email address"
                                maxLength={100}
                              />
                              {getButtonText() && (
                                <button
                                  className="thm-btn"
                                  onClick={handleSendMobileOtp}
                                  disabled={
                                    !canSendOtp || isProcessingOtp || isNewUser
                                  }
                                  style={{
                                    whiteSpace: "nowrap",
                                    minWidth: "150px",
                                    borderTopLeftRadius: 0,
                                    borderBottomLeftRadius: 0,
                                  }}
                                >
                                  {getButtonText()}
                                </button>
                              )}
                            </div>
                            {validateEmail() && <div className="invalid-feedback d-block">{validateEmail()}</div>}
                          </div>
                        ) : (
                          <MobileVerificationSection
                            onVerificationSuccess={(userData) => {
                              setVerifiedUser(userData);
                              const updatedDetails = {
                                ...userDetails,
                                firstName:
                                  userData.firstName || userDetails.firstName,
                                lastName:
                                  userData.lastName || userDetails.lastName,
                                email: userData.email || userDetails.email,
                                mobile: userData.mobile || userDetails.mobile,
                                countryCode:
                                  userData.countryCode ||
                                  userDetails.countryCode,
                              };
                              setUserDetails(updatedDetails);

                              // Update guest user in Redux store immediately after verification
                              dispatch(setGuestUserDetails(updatedDetails));

                              if (
                                userData.addresses &&
                                userData.addresses.length > 0
                              ) {
                                dispatch(setAddressList(userData.addresses));
                                handleAddressSelect(userData.addresses[0]._id);
                              }
                            }}
                            className="user-details-section"
                            otpLength={6}
                          />
                        )}

                        {showOtpInput && (
                          <div className="mt-3 text-center">
                            <label className="form-label">Enter OTP</label>
                            <OtpInput
                              length={4}
                              onOtpSubmit={(value) => setOtp(value)}
                            />
                            <button
                              className="thm-btn mt-3 mb-3 w-50"
                              onClick={handleVerifyOtp}
                              disabled={isVerifyingOtp || otp.length !== 4}
                            >
                              {isVerifyingOtp ? "Verifying..." : "Verify OTP"}
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* Contact Details Section */}
                <div className="col-lg-8 mb-4">
                  <div className="card shadow-sm border-0">
                    <div className="card-header bg-white">
                      <h5 className="mb-0">Contact Details</h5>
                    </div>
                    <div className="card-body">
                      <UserDetailsForm
                        values={userDetails}
                        setValues={setUserDetails}
                        showEmail={verifyMethod !== "email"}
                        showMobile={verifyMethod !== "mobile"}
                        loading={isProcessingPayment}
                        className="user-details-form"
                        recaptchaContainerId="checkout-recaptcha-container"
                        isGuest={!token}
                      />
                    </div>
                  </div>
                </div>

                {/* Delivery Address Section */}
                <div className="col-lg-8 mb-4">
                  <div className="card border-0 shadow-sm">
                    <div className="card-header bg-white py-3">
                      <h4 className="mb-0 fs-5">
                        <i className="fas fa-map-marker-alt me-2"></i>
                        Delivery Address
                      </h4>
                    </div>
                    <div className="card-body">
                      <Address1 onAddressSelect={handleAddressSelect} />
                    </div>
                  </div>
                </div>

                {/* Order Note Section */}
                <div className="col-lg-8 mb-4">
                  <OrderNoteSection
                    isOrderNoteChecked={isOrderNoteChecked}
                    setIsOrderNoteChecked={setIsOrderNoteChecked}
                    isOrderNoteText={isOrderNoteText}
                    setIsOrderNoteText={setIsOrderNoteText}
                  />
                </div>

                {/* Greeting Note Section */}
                <div className="col-lg-8 mb-4">
                  <GreetingNoteSection
                    isGreetingNoteChecked={isGreetingNoteChecked}
                    setIsGreetingNoteChecked={setIsGreetingNoteChecked}
                    isGreetingNoteText={isGreetingNoteText}
                    setIsGreetingNoteText={setIsGreetingNoteText}
                    selectedGreetingCard={selectedGreetingCard}
                    setSelectedGreetingCard={setSelectedGreetingCard}
                  />
                </div>

                {/* Payment Method */}
                <div className="col-lg-8 mb-4">
                  <div className="card border-0 shadow-sm">
                    <div className="card-footer bg-white">
                      <div className="d-flex justify-content-between align-items-center p-3">
                        <div>
                          <h5 className="mb-0">Payment Method</h5>
                          <p className="text-muted small mb-0">
                            Secure payment via Easebuzz Payment Gateway
                          </p>
                        </div>
                        <img
                          src={easebuzz_logo}
                          alt="Easebuzz"
                          style={{ width: "60px", height: "40px" }}
                        />
                      </div>

                      <hr />

                      <div className="d-flex justify-content-center">
                        <button
                          className="thm-btn w-50 mt-3 mb-3"
                          onClick={handlePayment}
                          disabled={isProcessingPayment || items.length === 0}
                        >
                          {isProcessingPayment ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" />
                              Processing...
                            </>
                          ) : (
                            `Pay ${
                              (
                                orderDetails?.summary?.finalAmount +
                                deliveryCharge
                              )?.toLocaleString("en-IN", {
                                style: "currency",
                                currency: "INR",
                              }) || "..."
                            }`
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Success Modal */}
      <div className="modal fade" id="success" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center p-4">
              <img
                src={successcart}
                alt=""
                className="mb-4"
                style={{ width: "100px" }}
              />
              <h4>Order Placed Successfully!</h4>
              {orderId && <h6>Order ID: {orderId}</h6>}
              <p className="text-muted">
                Your order has been placed successfully. You can track your
                order in the orders section.
              </p>
              <div className="mt-4">
                <Link
                  to="/myorder"
                  className="btn btn-primary me-2"
                  onClick={handleModalClose}
                >
                  View Orders
                </Link>
                <Link
                  to="/"
                  className="btn btn-secondary"
                  onClick={handleModalClose}
                >
                  Continue Shopping
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Checkout;
